(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('MessagesPortalService', MessagesPortalService);

  MessagesPortalService.$inject = ['$resource'];

  function MessagesPortalService ($resource) {
    return $resource(apiUrl + '/template-messages/:id', { id: '@id' }, {
      sendMessage: { url: apiUrl + '/messages-portal-send', method: 'POST', params: {}, isArray: false },
      getMessages: { url: apiUrl + '/messages-portal-get', method: 'GET', params: {}, isArray: false },
      getCpfValidation: { url: apiUrl + '/messages-portal-cpf', method: 'GET', params: {}, isArray: false },
      validateCpf: { url: apiUrl + '/messages-portal-validate-cpf', method: 'POST', params: {}, isArray: false },
      isValidCpf: { url: apiUrl + '/messages-portal-is-valid-cpf', method: 'POST', params: {}, isArray: false },
      isValidPhone: { url: apiUrl + '/messages-portal-is-valid-phone', method: 'POST', params: {}, isArray: false },
      checkMessageHsm: { url: apiUrl + '/check-message-hsm', method: 'GET', params: {}, isArray: false },
      checkHasOpenCard: { url: apiUrl + '/check-has-open-card', method: 'POST', params: {}, isArray: false },
      getCountries: { url: apiUrl + '/country/get-countries', method: 'GET', params: {}, isArray: false },
      getCompanyLocalization: { url: apiUrl + '/company-metadata-key/localization', method: 'GET', params: {}, isArray: false },
      stoneageValidation: { url: apiUrl + '/stoneage-validation-cpf-telephone', method: 'POST', params: {}, isArray: false }
    });
  }
})();
